import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-welcome',
    standalone: true,
    templateUrl: './welcome.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {

  constructor() { }

}
